import React, { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const CHERRFY_LOGO_URL =
  "https://raw.githubusercontent.com/hawkeye-bd/cherrfy-cdn/refs/heads/main/logo/cherrfy-logo.png";

export default function Maintenance({ mode = "down", onRetry }) {
  const isOffline = mode === "offline";
  const [logoFailed, setLogoFailed] = useState(false);
  const retryRef = useRef(null);

  useEffect(() => {
    if (retryRef.current) retryRef.current.focus();
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-white px-4 py-10"
      role="alert"
      aria-live="assertive"
    >
      <div className="w-full max-w-md text-center">
        {logoFailed ? (
          <div className="flex items-center justify-center gap-0.5">
            <span className="text-3xl font-extrabold tracking-tight text-slate-900 select-none">
              Cherrfy
            </span>
            <span className="text-3xl font-extrabold text-[#D2042D] select-none">.</span>
          </div>
        ) : (
          <img
            src={CHERRFY_LOGO_URL}
            alt="Cherrfy"
            className="mx-auto h-11 w-auto object-contain"
            onError={() => setLogoFailed(true)}
          />
        )}

        <h1 className="mt-12 text-2xl sm:text-[28px] font-bold tracking-tight text-slate-900">
          {isOffline ? "You appear to be offline" : "We’ll be right back"}
        </h1>

        <p className="mx-auto mt-3 max-w-sm text-sm sm:text-[15px] leading-relaxed text-slate-600">
          {isOffline
            ? "Your connection dropped, so we couldn’t reach Cherrfy. Your cart, orders, and saved addresses are safe — reconnect and everything will be right where you left it."
            : "Cherrfy is briefly down or under scheduled maintenance. Your cart, orders, and saved addresses are all safe — we’ll be shopping again soon."}
        </p>

        <button
          ref={retryRef}
          type="button"
          onClick={onRetry}
          className="mt-8 inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-xl bg-[#D2042D] px-8 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#b80326] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#D2042D]/25"
        >
          <RefreshCw size={15} aria-hidden="true" />
          Try again
        </button>

        <p className="mt-6 text-xs text-slate-400">
          This page checks the connection automatically and updates itself once
          Cherrfy is back.
        </p>
      </div>
    </div>
  );
}
